import React from "react";
import PageAncestor from "core/common/page/pageAncestor";
import Toolmenu from "core/components/toolmenu/toolmenu";
import mdEntityService from "core/metamodel/mdEntityService";
import jobService from "core/job/jobService";
import {ErrorComp} from "core/components/errorComp/errorComp";
import {FormProps, IDomainObject, preSave} from "core/form/formUtils";
import {parseId} from "core/common/utils/utils";
import gridService from "core/grid/gridService";
import GridComp, {UILOCATION} from "core/grid/component/gridComp";
import Grid from "core/grid/domain/grid";
import ConfirmationDialog from "core/components/confirmationDialog/confirmationDialog";
import TriggerForm from "core/job/triggerForm";
import {MODULE, PageProps, PERMISSION, SECURABLE} from "core/metamodel/metaConstant";
import {observer} from "mobx-react";
import {JobInfo, TriggerInfo} from "core/job/jobDomain";
import {MovingBlocks} from "core/grid/gridUtils";
import uiService from "core/common/service/uiService";
import {action} from "mobx";
import {WithDeleteDialogZzFlatButton, ZzFlatButton} from "core/components/buttons/buttons";
import * as JobDetailForms from "core/job/jobDetailForms";
import {loc} from "../common/config/locales";
import securityService from "../security/securityService";
import commonService from "../common/service/commonService";

export const jobHistoryGridLocation = 'jobHistoryList';
export const triggerGridLocation = 'triggerList';

@observer
export default class JobDetail extends PageAncestor<PageProps, undefined> {

  static module = MODULE.core;
  static title = 'JobInfo';
  static icon = 'cogs';
  static protectedPage = true;


  static fetchData(routerParams, query) {
    console.log("JobDetail#fetchData(%O)", query);

    let metadataPromise = mdEntityService.fetchEntityMetadata(['JobInfo', 'JobLog', 'TriggerInfo']);

    let jobPromise = jobService.readJob(routerParams.id);


    let gridPromise = gridService.fetchGrids(jobHistoryGridLocation, triggerGridLocation);

    return Promise.all([metadataPromise, jobPromise, gridPromise])
      .then(([entityMap, jobObject, gridLocationMap]: [any, JobInfo, any]) => {
        jobObject.$new = query.new;
        if (jobObject.$new) jobObject.$dirty = true;

        jobObject.$movingBlocks = new MovingBlocks(null, false, null,
          new Grid(gridLocationMap.get(triggerGridLocation), jobObject.id),
          new Grid(gridLocationMap.get(jobHistoryGridLocation), jobObject.id) );

        jobService.jobObject = jobObject.initAfterRead(jobObject.$new);
      });
  }




  /**
   * tohle je tady kvuli prechodu na jiny detail invoice (chained details)
   * @param prevProps
   */
  componentDidUpdate(prevProps: PageProps) {
    if( (prevProps.query.new && !this.props.query.new)  // protoze id neni generovane
        || this.idChanged(prevProps.params.id, this.props.params.id) ) {
      jobService.jobObject.$movingBlocks.searchExposedGrids(jobService.jobObject);
    }
  }

  componentDidMount() {
    jobService.jobObject.$movingBlocks.searchExposedGrids(jobService.jobObject);
  }

  componentWillUnmount() {
    jobService.jobObject = null;
  }



  customValidate = (jobObject) => {
    let errors = [];

    return errors;
  };


  findRootObject() {
    return jobService.jobObject;
  }



  @action onSave = (evt) => {
    console.log('onSave ', jobService.jobObject);
    uiService.showToolbarActionFlag();

    let result = preSave(jobService.jobObject, this.customValidate);
    if (!result) {
      return;
    }

    jobService.jobSave(jobService.jobObject.createDataObjectDto())
      .then( action("jobSave-callback", (jobJson: IDomainObject) => {

        let wasNew = jobService.jobObject.cleanAfterSave(jobJson);
        if(wasNew) {
          this.context.router.replaceWith('jobDetail', {id: jobService.jobObject.id});   // {id: formatId(jobObject.group, jobObject.name)}
          window.location.reload(true);
        }
        uiService.hideToolbarActionFlag();
      }), error => {
        jobService.jobObject.$errors = error.getMessages();
      });

  };


  @action onDelete = (evt) => {
    console.log('onDelete');

    jobService.deleteJob(jobService.jobObject)
      .then(response => {
        this.context.router.transitionTo('jobList');
      }, error => {
        jobService.jobObject.$errors = error.getMessages();
      })
  };


  @action onAddTrigger = (evt) => {
    console.log('onAddTrigger');
    let grid: Grid = jobService.jobObject.$movingBlocks.getBlock(triggerGridLocation) as Grid;
    let rowObject = new TriggerInfo({
      misfirePolicy: {value: 'DO_NOTHING', label: 'DO_NOTHING'},
      $new: true,
      $dirty: true,
      $added: true
    }).initDefaultValues();
    grid.addRow(rowObject);
    let form = rowObject.getForm('TriggerForm');
    form.$open = true;

    jobService.jobObject.$dirty = true;
  };


  @action onRunNow = (evt) => {
    console.log('onRunNow');

    jobService.oneOff(jobService.jobObject)
      .then(res => {
        jobService.jobObject.$movingBlocks.searchExposedGrids(jobService.jobObject, true);
      });
  };



  refresh = (evt) => {
    console.log('refresh');
    jobService.jobObject.$movingBlocks.searchExposedGrids(jobService.jobObject, true);
  };

  switchState = (rowId) => {
    console.log('switchState %s', rowId);
    let jobObject = jobService.jobObject;

    if (!jobObject.$new && !securityService.hasRight(SECURABLE.jobDetail.name, PERMISSION.Update, jobObject.id as string)) {
      commonService.notifyError( "You do not have permission to enable or disable schedule of this job", "Error");
      return;
    }

    let strings = parseId(rowId);
    jobService.switchState(new TriggerInfo({group: strings[0], name: strings[1]}))
      .then(res => {
        jobObject.$movingBlocks.getBlock(triggerGridLocation).search(jobObject, true);
      });
  };



  render() {

    const {
      query,
      } = this.props;

    // const propsForCreateForm = {
    //   dataObject: jobService.jobObject,
    //   rootObject: jobService.jobObject,
    //   entity: mdEntityService.getEntity("JobInfo"),
    //   entities: mdEntityService.entityMap
    // };

    console.debug('%c jobDetail render query %O', 'background-color: yellow', this.props.query);

    let jobObject = jobService.jobObject;
    let movingBlocks = jobObject.$movingBlocks;

    // let triggerGrid = Grid.safeGet(jobObject, triggerGridLocation);
    // let jobHistoryGrid = Grid.safeGet(jobObject, jobHistoryGridLocation);

    const rowTriggerForm = (
      <TriggerForm rootObject={jobObject} entity={mdEntityService.getEntity('TriggerInfo')} entities={mdEntityService.entityMap} dataObject={null}/>
    );


    let detailComponent;
    if (jobObject.detailComponent) {
      let enabled = (!jobObject.$new && securityService.hasRight(SECURABLE.jobDetail.name, PERMISSION.Update, jobObject.id.toString())) || (jobObject.$new && securityService.hasRight(SECURABLE.jobDetail.name, PERMISSION.New));
      let DetailComponentForm: React.ComponentClass<FormProps<any, JobInfo>> = JobDetailForms[jobObject.detailComponent + 'Form'];
      detailComponent = <DetailComponentForm dataObject={jobObject} rootObject={jobObject}
                               entities={mdEntityService.entityMap} entity={mdEntityService.getEntity('JobInfo')} disabled={!enabled}/>
    } else {
      detailComponent = (<h3>{jobObject.group + ' - ' + jobObject.name}</h3>);
    }


    return (

      <main className="main-content" style={{display: 'flex', flexDirection: 'column'}}>
        {this._createToolMenu(jobObject, query.gridLocation)}
        <ErrorComp messages={jobObject.$errors}/>
        <ConfirmationDialog ref={this.dirtyDialogRefHandler}/>
        <ConfirmationDialog ref={this.deleteDialogRefHandler} okButtonText={loc.i18n`Yes`} cancelButtonText={loc.i18n`No`}/>

        <form style={{marginTop: 10}}>
          {detailComponent}
        </form>

        <h5>Triggers</h5>

        <GridComp ref={triggerGridLocation} grid={movingBlocks.getBlock(triggerGridLocation) as Grid}  hideToolbar={true}
                  uiLocation={UILOCATION.main}
                  showEdit={securityService.hasRight(SECURABLE.jobDetail.name, PERMISSION.Update, jobObject.$new ? undefined : jobObject.id as string)}
                  showDelete={securityService.hasRight(SECURABLE.jobDetail.name, PERMISSION.Update, jobObject.$new ? undefined : jobObject.id as string)}
                  deleteRowIcon="fa fa-trash" rootObject={jobObject}
                  editForm={rowTriggerForm} editFormName="TriggerForm" entities={mdEntityService.entityMap} functionMap={{switchState: this.switchState.bind(this)}} />


        <h5>Run History</h5>
        <GridComp grid={movingBlocks.getBlock(jobHistoryGridLocation) as Grid} uiLocation={UILOCATION.main} entities={mdEntityService.entityMap} hideToolbar={true}/>

        <h6>Possible Trigger state explained:</h6>
        <table className="table table-condensed fullwrap">
          <tbody>
          <tr>
            <td className="color-green-500" style={{width: 80}}>NORMAL</td>
            <td>Indicates that the Trigger is in the "normal" state.</td>
          </tr>
          <tr>
            <td className="color-green-500">BLOCKED</td>
            <td>Indicates that the Trigger is in the "blocked" state. A Trigger arrives at the blocked state when the job that it is associated with is a StatefulJob and it is currently executing.</td>
          </tr>
          <tr>
            <td className="color-grey-500">PAUSED</td>
            <td>Indicates that the Trigger is in the "paused" state.</td>
          </tr>
          <tr>
            <td className="color-grey-500">COMPLETE</td>
            <td>Indicates that the Trigger is in the "complete" state. "Complete" indicates that the trigger has not remaining fire-times in its schedule.</td>
          </tr>
          <tr>
            <td className="color-red-500">ERROR</td>
            <td>Indicates that the Trigger is in the "error" state. A Trigger arrives at the error state when the scheduler attempts to fire it, but cannot due to an error creating and executing its related job. Often this is due to the Job's class not existing in the classpath. When the trigger is in the error state, the scheduler will make no attempts to fire it.</td>
          </tr>
          </tbody>
        </table>

      </main>


  );
  }



  _createToolMenu(jobObject, gridLocation) {
    return (
      <Toolmenu chainGridLocation={gridLocation} backAction={this.onBack} backDisabled={History.length <= 1}>
        <ZzFlatButton onClick={this.onSave} disabled={!jobObject.$dirty} label="Save" permission={jobObject.$new ? PERMISSION.New : PERMISSION.Update} detailId={jobObject.$new ? undefined : jobObject.id}/>
        <WithDeleteDialogZzFlatButton entityName="JobInfo" pageAncestor={this} onClick={this.onDelete} disabled={jobObject.$new} label="Delete" permission={PERMISSION.Delete} detailId={jobObject.id}/>
        <ZzFlatButton onClick={this.onAddTrigger} label="Add Trigger" permission={jobObject.$new ? PERMISSION.New : PERMISSION.Update} detailId={jobObject.$new ? undefined : jobObject.id}/>
        <ZzFlatButton onClick={this.onRunNow} disabled={jobObject.$new} label="Run Now!" permission={PERMISSION.Execute} detailId={jobObject.id}/>
        <ZzFlatButton onClick={this.refresh} disabled={jobObject.$new} label="Refresh"/>
      </Toolmenu>
    );
  }


}





// WEBPACK FOOTER //
// ./src/core/job/jobDetail.tsx